var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIlInsertDocument(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 10.4551,
    width: 54,
    height: 37,
    rx: 4.24675,
    fill: "#2EBCFC",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4004 4H29.4004L37.4004 12V36H13.4004V4Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4004 2.5C14.4058 2.5 13.452 2.89509 12.7487 3.59835C12.0455 4.30161 11.6504 5.25544 11.6504 6.25V33.75C11.6504 34.7446 12.0455 35.6984 12.7487 36.4016C13.452 37.1049 14.4058 37.5 15.4004 37.5H35.4004C36.395 37.5 37.3488 37.1049 38.052 36.4016C38.7553 35.6984 39.1504 34.7446 39.1504 33.75V13.535C39.1498 12.541 38.7546 11.5878 38.0516 10.885L30.7666 3.5975C30.0633 2.89465 29.1097 2.49988 28.1154 2.5H15.4004ZM14.1504 6.25C14.1504 5.91848 14.2821 5.60054 14.5165 5.36612C14.7509 5.1317 15.0689 5 15.4004 5H26.6504V11.25C26.6504 12.2446 27.0455 13.1984 27.7487 13.9017C28.452 14.6049 29.4058 15 30.4004 15H36.6504V33.75C36.6504 34.0815 36.5187 34.3995 36.2843 34.6339C36.0499 34.8683 35.7319 35 35.4004 35H15.4004C15.0689 35 14.7509 34.8683 14.5165 34.6339C14.2821 34.3995 14.1504 34.0815 14.1504 33.75V6.25ZM36.1329 12.5H30.4004C30.0689 12.5 29.7509 12.3683 29.5165 12.1339C29.2821 11.8995 29.1504 11.5815 29.1504 11.25V5.5175L36.1329 12.5Z",
    fill: "#444444"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3372 46.2569H40.8457L43.2095 52.0146C43.3742 52.4138 43.186 52.8614 42.8097 53.0307L40.7281 53.9379C40.3401 54.1073 39.9049 53.9137 39.7403 53.5266L37.4941 48.0592L33.8249 51.8332C33.3359 52.336 32.543 51.9484 32.543 51.2889V33.097C32.543 32.4027 33.3864 32.0642 33.8248 32.5527L45.8664 44.9385C46.3521 45.4118 45.9937 46.2569 45.3372 46.2569Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIlInsertDocument);
export default __webpack_public_path__ + "static/media/il-insert-document.f876bf97debc5f4b9732c52159960f4f.svg";
export { ForwardRef as ReactComponent };